import { postIa } from "api/iaBackend";

export type TextWritingAction =
  | "translate"
  | "analyze"
  | "longer"
  | "shorter"
  | "explain"
  | "spellcheck";

export const REWRITE_ACTIONS: TextWritingAction[] = [
  "translate",
  "longer",
  "shorter",
  "spellcheck"
];

export function isRewriteAction(action: TextWritingAction): boolean {
  return REWRITE_ACTIONS.includes(action);
}

export const TRANSLATE_LANGUAGES = [
  { code: "FR", label: "Français" },
  { code: "EN", label: "English" },
  { code: "DE", label: "Deutsch" },
  { code: "ES", label: "Español" },
  { code: "IT", label: "Italiano" }
] as const;

export type TranslateLangCode = (typeof TRANSLATE_LANGUAGES)[number]["code"];

interface AssistTextWritingParams {
  action: TextWritingAction;
  text: string;
  targetLang?: TranslateLangCode;
}

export async function assistTextWriting({
  action,
  text,
  targetLang
}: AssistTextWritingParams): Promise<string> {
  const trimmed = text.trim();
  if (!trimmed) {
    throw new Error("Aucun texte à traiter");
  }

  const data = await postIa<{ text: string }>("/ia/writing-assist", {
    action,
    text: trimmed,
    targetLang
  });
  const result = data?.text?.trim();
  if (!result) {
    throw new Error("Pas de réponse de l'assistant");
  }
  return result;
}
